import React from "react"
import { Box, Stack, Typography } from "@mui/material"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import { COLORS } from "../../utils"
import { PSES_SIDEBAR_MENUS_LABELS } from "../../utils/productionStepExecution"


const NoPSEs = ({
  selectedMenu,
  statusNotificationCounts,
  selectedStatus,
  mode = "PSE"
}) => {
  if (statusNotificationCounts.total === 0) {
    return (
      <Box sx={styles.emptyState}>
        <Typography style={styles.emptyData}>
          Aucune étape {selectedMenu ? PSES_SIDEBAR_MENUS_LABELS[selectedMenu.toUpperCase()].toLowerCase() : " de production"}
        </Typography>
      </Box>
    )
  }

  return (
    <Box sx={styles.emptyState}>
      {(statusNotificationCounts.total === statusNotificationCounts[selectedStatus])
        ? (
          <Stack spacing={1} alignItems="center">
            {mode === "PSE" ? <>
              <Box className="flexCenter">
                <CheckCircleIcon sx={{ color: "#48B468", width: 32, height: 32 }} />
              </Box>
              <Typography style={styles.emptyData}>
                Toutes les étapes ont bien été cuisinées
              </Typography>
            </> :
              <Typography style={styles.emptyData}>
                Aucune barquette ici pour le moment
              </Typography>}
          </Stack>
        ) : (
          <Typography style={styles.emptyData}>
            Aucune étape de production
          </Typography>
        )}
    </Box>
  )
}

const styles = {
  emptyState: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "200px",
  },
  emptyData: {
    fontSize: "20px",
    color: COLORS.BLACK800,
    textAlign: "center",
    lineHeight: 1.4,
    fontWeight: 500,
  },
}

export default NoPSEs
